module.exports = __webpack_public_path__ + "img/full1-min.332ff998.png";